import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { AutomationExecutionEntity } from './automation-execution.entity';
import { AutomationFlowEntity } from './automation-flow.entity';
import { AutomationStepConnectionEntity } from './automation-step-connection.entity';
import { AutomationStepExecutionEntity } from './automation-step-execution.entity';
import { AutomationVersionEntity } from './automation-version.entity';
import { BaseEntity } from './base.entity';

@Entity('_automation_step')
export class AutomationStepEntity extends BaseEntity {
	@Column({
		name: '_fk__automation_flow__id',
		type: 'int',
		unsigned: true,
	})
	public flowId!: number;

	@Column({
		name: '_step_type',
		type: 'varchar',
		length: 100,
	})
	public stepType!: string;

	@Column({ name: '_step_name', type: 'varchar', length: 255 })
	public stepName!: string;

	@Column({
		name: '_internal_id',
		type: 'varchar',
		length: 36,
		nullable: true, // Will be NOT NULL after migration
		comment: 'Persistent UUID for step identification and variable references',
	})
	public internalId?: string;

	@Column({ name: '_step_order', type: 'int' })
	public stepOrder!: number;

	@Column({
		name: '_fk__parent_automation_step__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public parentStepId?: number;

	@Column({
		name: '_branch_condition',
		type: 'varchar',
		length: 50,
		nullable: true,
	})
	public branchCondition?: string;

	@Column({ name: '_config', type: 'json' })
	public config!: Record<string, any>;

	@Column({
		name: '_list_configuration_id',
		type: 'varchar',
		length: 255,
		nullable: true,
	})
	public listConfigurationId?: string;

	@Column({ name: '_list_id', type: 'varchar', length: 255, nullable: true })
	public listId?: string;

	@Column({ name: '_position_x', type: 'int', default: 0 })
	public positionX!: number;

	@Column({ name: '_position_y', type: 'int', default: 0 })
	public positionY!: number;

	@Column({ name: '_is_active', type: 'boolean', default: true })
	public isActive!: boolean;

	@Column({
		name: '_fk__automation_version__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public versionId?: number;

	@ManyToOne(() => AutomationFlowEntity, (flow) => flow.steps)
	@JoinColumn({ name: '_fk__automation_flow__id' })
	public flow!: AutomationFlowEntity;

	@ManyToOne(() => AutomationVersionEntity, (version) => version.steps)
	@JoinColumn({ name: '_fk__automation_version__id' })
	public version?: AutomationVersionEntity;

	@ManyToOne(() => AutomationStepEntity, (step) => step.childSteps)
	@JoinColumn({ name: '_fk__parent_automation_step__id' })
	public parentStep?: AutomationStepEntity;

	@OneToMany(() => AutomationStepEntity, (step) => step.parentStep)
	public childSteps!: AutomationStepEntity[];

	@OneToMany(() => AutomationStepExecutionEntity, (execution) => execution.step)
	public executions!: AutomationStepExecutionEntity[];

	@OneToMany(
		() => AutomationStepConnectionEntity,
		(connection) => connection.fromStep,
	)
	public outgoingConnections!: AutomationStepConnectionEntity[];

	@OneToMany(
		() => AutomationStepConnectionEntity,
		(connection) => connection.toStep,
	)
	public incomingConnections!: AutomationStepConnectionEntity[];

	@OneToMany(
		() => AutomationExecutionEntity,
		(execution) => execution.currentStep,
	)
	public currentExecutions!: AutomationExecutionEntity[];

	// Getter for compatibility with step handlers
	public get type(): string {
		return this.stepType;
	}
}
